<bn-loading-overlay></bn-loading-overlay>
<h5>Inadimplemento Operacional</h5>
<div class="container">
    <form [formGroup]="pesquisaForm" class="mt-3 mx-auto" (keyup.enter)="focusableSubmit.click()" >
        <div class="row">
            <div class="col">
                <h3>Filtros de pesquisa</h3>
            </div>
            
            <div class="col-auto" *ngIf="podeCadastrarInadimplencia">
                <button class="btn btn-primary no-margin" type="button" [routerLink]="['/inadimplencia']" 
                  ngbTooltip="Tela para cadastro de Inadimplemento Operacional."><i class="fa fa-file-signature">
                  </i> Cadastrar novo Inadimplemento Operacional
                </button>
            </div> 

            <div class="col-auto">
                <button type="button" class="btn btn-light" (click)="limpar()">Limpar</button>
            </div>      

            <div class="col-auto">
                <button #focusableSubmit type="button" class="btn btn-success no-margin" (keydown.enter)="buscar()" (click)="buscar()"
                    [disabled]="!pesquisaForm.valid" >Pesquisar
                </button>
            </div>

        </div>

        <div class="row"> 
            <div class="bn-form-group col-md-12">
                <label class="form-label">Agente Financeiro:</label>
                <ng-select
                    id="idAgenteFinanceiro"
                    [items]="agentesFinanceiros"
                    bindLabel="nome"
                    [multiple]="false"
                    [clearable]="true"
                    [clearOnBackspace]="true"
                    formControlName="idAgenteFinanceiro"
                    [searchable]="true"
                    bindValue="id"
                    placeholder="Todos"
                    class="auto-grow">
                    <ng-template ng-label-tmp let-item="item">
                        {{ item.nome }}
                    </ng-template>
                </ng-select>
            </div> 

            <div class="bn-form-group col-md-3">
                <label class="form-label">Data de criação inicial:</label>
                <bn-datepicker 
                    name="dataCriacaoInicial" 
                    idInput="dataCriacaoInicial" 
                    ngDefaultControl
                    formControlName="dataCriacaoInicial">
                </bn-datepicker>
            </div>

            <div class="bn-form-group col-md-3">
                <label class="form-label">Data de criação final:</label>
                <bn-datepicker 
                    name="dataCriacaoFinal" 
                    idInput="dataCriacaoFinal" 
                    ngDefaultControl
                    formControlName="dataCriacaoFinal">
                </bn-datepicker>
            </div>

            <div class="bn-form-group col-md-3">
                <label class="form-label">Data de desativação inicial:</label>
                <bn-datepicker 
                    name="dataDesativacaoInicial" 
                    idInput="dataDesativacaoInicial" 
                    ngDefaultControl
                    formControlName="dataDesativacaoInicial" >
                </bn-datepicker>
            </div>

            <div class="bn-form-group col-md-3">
                <label class="form-label">Data de desativação final:</label>
                <bn-datepicker
                    name="dataDesativacaoFinal" 
                    idInput="dataDesativacaoFinal" 
                    ngDefaultControl
                    formControlName="dataDesativacaoFinal">
                </bn-datepicker>
            </div>

            <div class="bn-form-group col-md-6">
                <label class="form-label">Motivo:</label>
                <input class="form-control" name="motivo" ngDefaultControl formControlName="motivo">
            </div>

            <div class="bn-form-group col-md-3">
                <label class="form-label" for="tipoBloqueio">Tipo de Bloqueio: </label>
                <select id="tipoBloqueio" class="form-select" formControlName="tipoBloqueio" ngDefaultControl>
                    <option [ngValue]=null>Todos</option>
                    <option [ngValue]="tipo.codigo" *ngFor="let tipo of tiposBloqueio" >{{ tipo.label }}</option>
                </select>
            </div>

            <div class="bn-form-group col-md-3">
                <label class="form-label" for="situacao" ngbTooltip="Considera como Ativo os registros com data fim não preenchida ou ainda válida.">Situação: </label>
                <select id="situacao" class="form-select" formControlName="situacao" ngDefaultControl>
                    <option [ngValue]=null>Todos</option>
                    <option [ngValue]="sit.codigo" *ngFor="let sit of situacao" >{{ sit.label }}</option>
                </select>
            </div>

        </div>
    </form>
</div>
<app-inadimplencia-listagem
    [inadimplencias]="inadimplencias"
    [atributosPaginacao]="atributosPaginacaoComponenteListagem"
    [podeCadastrarInadimplencia]="podeCadastrarInadimplencia"
    (aoMudarPagina)="mudancaPagina($event)"
    (exportarInadimplementos)="exportarInadimplementos()"
    (excluirInadimplemento)="excluirInadimplemento($event)">
</app-inadimplencia-listagem>